<!-- <div class="form-group">
    <mat-form-field>
        <input matInput readonly [value]="getInputValue()">
        <mat-placeholder class="calendar-placeholder">{{this.label}}</mat-placeholder>
        <mat-icon matSuffix class="date-picker-trigger"><i class="fas fa-calendar-day"></i></mat-icon>
    </mat-form-field>
</div> -->
<multiple-date-picker #picker [(ngModel)]="this.value" [sundayFirstDay]="false"></multiple-date-picker>
